import React from "react";

function SvgIconNest(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 211.667 211.667" {...props}>
      <g transform="translate(-903.642 -329.315) scale(6.15385)">
        <circle
          cx={164.04}
          cy={70.712}
          r={17.198}
          fill="#cae8dc"
          fillRule="evenodd"
        />
        <path
          d="M180.962 72.585s-6.306 1.391-10.54 2.564c-3.909 1.083-7.577.465-8.007.526-.43.06-1.207.321-4.04.626-2.063.222-3.2.154-3.125.516.06.298 4.347-.116 5.36-.109 1.015.008 1.82-.167 2.846.257 1.026.424.624.393-.329.994-.217.137-.7.356-.616.61.083.253 2.13-.803 3.235-1.208 1.106-.406 7.486-2.25 9.755-2.434 2.269-.185 5.124-.013 5.124-.013s.446-.895.337-2.33z"
          fill="#024a31"
          fillRule="evenodd"
        />
        <path
          d="M160.694 83.808s2.051-1.236 2.531-2.105c.96-1.74-.097-2.304-.097-2.304s-1.041-.594-2.001 1.146c-.48.869-.433 3.263-.433 3.263zm-2.118-4.889s1.591.701 2.308.623c1.435-.157 1.329-1.021 1.329-1.021s-.084-.867-1.518-.71c-.717.079-2.12 1.108-2.12 1.108zm-8.113.584s2.38.269 3.29-.13c1.82-.795 1.325-1.886 1.325-1.886s-.465-1.105-2.286-.31c-.91.398-2.33 2.326-2.33 2.326zm4.919-6.309s-1.021 1.22-1.135 1.869c-.228 1.3.558 1.427.558 1.427s.782.147 1.01-1.152c.114-.65-.432-2.144-.432-2.144zm-4.589 1.295s.745 1.405 1.304 1.755c1.118.7 1.531.02 1.531.02s.432-.669-.687-1.37c-.559-.35-2.148-.405-2.148-.405z"
          fill="#fa6547"
          fillRule="evenodd"
        />
        <path
          d="M171.767 72.97c.208.623 1.977 2.073 4.103 1.596 2.125-.476 2.577-2.897 2.4-3.45-.178-.553-.912-1.41-3.828-.644-2.917.765-2.82 2.06-2.675 2.498z"
          fill="#9ecb9a"
          fillRule="evenodd"
        />
        <ellipse
          transform="rotate(-14.504)"
          cx={151.394}
          cy={112.713}
          rx={2.553}
          ry={0.698}
          opacity={0.873}
          fill="#024a30"
          fillOpacity={0.867}
          fillRule="evenodd"
        />
        <path
          d="M164 71.733l.41 4.036m-2.606-4.437l-.667 4.601"
          fill="#323232"
          fillRule="evenodd"
          stroke="#323232"
          strokeWidth={0.169}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.959 68.042l-2.075.747s-1.908 4.15-5.891 2.614c-3.983-1.535-6.182-4.522-6.182-4.522l-3.278 1.244-.373-3.36s5.518-.623 6.555-.913c1.037-.29 4.647-1.867 7.26-.83 2.614 1.037 2.905 2.946 3.03 3.9z"
          fill="#476c72"
          fillRule="evenodd"
        />
        <path
          d="M174.74 68.153c-.014-.084.18-.898.54-.609.252.202-.15.381-.15.381"
          fill="none"
          stroke="#323232"
          strokeWidth={0.107}
          strokeLinecap="round"
        />
        <path
          d="M172.716 68.428l.813-.02s.813-.812 1.552-.11c.739.702.813 2.216.96 2.364.148.148.887.409.887.409s-1.683 1.227-3.14.847c-1.293-.406-.517-2.808-.517-2.808z"
          fill="#476c72"
          fillRule="evenodd"
        />
        <path
          d="M155.81 66.88s6.262-2.912 6.985-.922c.724 1.99-1.308 4.92-6.984.923zm20.198 3.755s-.779-1.02-1.182-.751c-.402.268-.483 1.557 1.182.751z"
          fill="#fa6547"
          fillRule="evenodd"
        />
        <ellipse
          cx={177.114}
          cy={27.151}
          rx={0.693}
          ry={0.991}
          transform="rotate(13.191)"
          fill="#e1e1e1"
          fillRule="evenodd"
        />
        <ellipse
          transform="rotate(13.191)"
          ry={0.64}
          rx={0.447}
          cy={27.207}
          cx={177.383}
          fill="#323232"
          fillRule="evenodd"
        />
        <ellipse
          transform="scale(-1 1) rotate(-17.429)"
          ry={0.412}
          rx={0.288}
          cy={13.62}
          cx={-186.791}
          fill="#e1e1e1"
          fillRule="evenodd"
        />
        <ellipse
          cx={-186.679}
          cy={13.643}
          rx={0.186}
          ry={0.266}
          transform="scale(-1 1) rotate(-17.429)"
          fill="#323232"
          fillRule="evenodd"
        />
        <path
          d="M169.959 68.042l-.955-1.12-1.12 1.867zm2.757.386l.813-.02-.258.702z"
          fill="#fa6547"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default SvgIconNest;

